import React from 'react';
import PropTypes from 'prop-types';
import { viewports } from '../helper';
import { useViewport } from '../Grid/config';

const Hidden = _ref => {
  let {
    children,
    only
  } = _ref;
  const viewport = useViewport();
  if (!only) return null;
  let visible = true;

  if (Array.isArray(only)) {
    for (let i = 0; i < only.length; i++) {
      if (viewport === only[i]) {
        visible = false;
      }
    }
  } else if (only === viewport) {
    visible = false;
  }

  if (!visible) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};

Hidden.displayName = 'Hidden';
Hidden.viewports = {
  smallMobile: viewports.smallMobile,
  mobile: viewports.mobile,
  tablet: viewports.tablet,
  desktop: viewports.desktop,
  largeDesktop: viewports.largeDesktop
};
Hidden.defaultProps = {
  children: null,
  only: null
};
Hidden.propTypes = {
  /**
   * Hide only in breaking point specified.
   *
   * Should pass one or array of `Hidden.viewports.smallMobile`, `Hidden.viewports.mobile`, `Hidden.viewports.tablet`, `Hidden.viewports.desktop`, `Hidden.viewports.largeDesktop`
   */
  only: PropTypes.oneOfType([PropTypes.oneOf([Hidden.viewports.smallMobile, Hidden.viewports.mobile, Hidden.viewports.tablet, Hidden.viewports.desktop, Hidden.viewports.largeDesktop]), PropTypes.arrayOf(PropTypes.oneOf([Hidden.viewports.smallMobile, Hidden.viewports.mobile, Hidden.viewports.tablet, Hidden.viewports.desktop, Hidden.viewports.largeDesktop]))]),

  /**
   * Sets the children.
   */
  children: PropTypes.node
};
export default Hidden;